export enum WorksheetType {
  Download = 0,
  Gallery = 1,
  ProviderVideo = 2,
  Link = 3,
}
